const ja = {
    enter_code: "セッションID",
    connect: "接続",
    check_your_internet_connection: "インターネット接続を確認してください。",
    network_error: "ネットワークエラー",
    server_error: "サーバーエラー",
    check_server_connection: "内部サーバーエラー",
    downtime: "ダウンタイム",
    server_is_currently_facing_downtime: "サーバーは現在ダウンタイムに直面しています",
    show_what_you_see: "あなたが見るものを見せてください",
    by_joining_i_confirm_that_i_have_read_and_understand_the: "プライバシー ポリシーを読み、同意することを確認します。",
    privacy_policy: "プライバシーポリシー",
    invalid_code: "セッション ID が無効です",
    code_should_be_of_nine_digits: "セッション ID は 9 桁である必要があります",
    blitzz: "ブリッツ",
    please_enter_your_name: "お名前を入力してください",
    maximum_value_is_30: "名前は 30 文字未満にする必要があります。",
    please_enter_meeting_id: "セッションIDを入力してください",
    please_try_again: "もう一度やり直してください。",
    no_one_is_sharing_video: "誰もビデオを共有していません。",
    retry: "リトライ",
    reconnect: "再接続",
    left_the_conversation: "会話を離れた",
    enabled_the_audio: "オーディオを有効にしました",
    disabled_the_audio: "オーディオを無効にしました",
    enabled_the_video: "ビデオを有効にしました",
    disabled_the_video: "ビデオを無効にしました",
    failed_to_join_room: "ルームに参加できませんでした",
    alert: "アラート",
    override_video_sharing_message: "現在の画面共有を終了して、ビデオの共有を開始しますか?",
    override_screen_sharing_message: "現在の画面共有を終了して、画面の共有を開始しますか?",
    override_video_sharing_with_screen_capturing_message: "現在のビデオを終了して、画面の共有を開始しますか?",
    override_screen_sharing_with_video_sharing_message: "現在の画面共有を終了して、ビデオの共有を開始しますか?",
    yes: "はい",
    cancel: "キャンセル",
    joined_the_call: "通話に参加しました",
    waiting_for_other_members_to_join_the_call: "他のメンバーが通話に参加するのを待っています",
    warning: "警告",
    camera_permission_disabled: "カメラにアクセスできません。",
    microphone_permission_disabled: "マイクにアクセスできません。",
    location_permission_disabled: "現在地にアクセスできません。",
    storage_permission_disabled: "ストレージにアクセスできません",
    permission_error_message_camera: "デバイス設定からカメラを有効にしてください。",
    permission_error_message_microphone: "デバイス設定からマイクを有効にしてください。",
    permission_location_error_message: "デバイス設定から位置情報を有効にしてください。",
    permission_storage_error_message: "デバイス設定からストレージを有効にしてください。",
    give_permission: "許可を与える",
    please_wait_for_five_seconds_to_take_screenshot: "別の写真を撮るため、5 秒間お待ちください",
    please_wait_for: "お待ちください",
    seconds_to_take_screen_shot: "数秒で別の写真を撮影できます。",
    second_to_take_screen_shot: "2番目に別の写真を撮ります。",
    invalid_information_received_from_server: "サーバーから無効な情報を受信しました。",
    unable_to_share_screen_as_no_one_else_has_joined_the_conversation_yet: "まだ誰も会話に参加していないため、ビデオを共有できません",
    successfully_uploaded: "正常にアップロードされました",
    disconnected: "切断されました",
    call_ended_as_no_one_else_had_joined_the_call: "他に誰も参加していないため、切断されました。",
    application_update_required: "アプリケーションの更新が必要です",
    update_required_message: "古いバージョンのアプリケーションを使用しているようです。App Store から更新してください。",
    update: "アップデート",
    image_marking_started: "画像マーキング開始",
    image_marking_stopped: "画像マーキング停止",
    settings: "設定",
    camera_permission_rationale: "カメラにアクセスする必要があります。カメラの許可を与えてください",
    microphone_permission_rationale: "マイクにアクセスする必要があります。マイクの許可を与えてください",
    location_permission_rationale: "現在地へのアクセスが必要です。位置情報を許可してください",
    storage_permission_rationale: "あなたのストレージにアクセスする必要があります。ストレージの許可を与えてください",
    call_between_two_customers: "エージェントは参加していません。しばらくしてから再試行してください。",
    media_projection_permission_needed_for_screen_sharing: "画面共有にはメディア投影の許可が必要です。",
    poor_network_connection: "警告！ネットワーク接続が悪い",
    you_are_the_only_person_in_the_call: "通話相手はあなただけです",
    image_has_been_captured_and_started_uploading: "画像がキャプチャされ、アップロードが開始されました",
    version: "バージョン",
    please_enter_the_code_provided_to_you: "提供されたコードを入力してください。",
    start_screen_share: "画面を共有する",
    stop_screen_share: "共有を停止",
    flip_camera: "カメラを反転",
    take_photo: "写真を撮る",
    flash_off: "フラッシュオフ",
    flash_on: "フラッシュオン",
    start_markup: "マークアップを開始",
    stop_markup: "マークアップを停止",
    speaker_off: "スピーカーオフ",
    speaker_on: "スピーカーオン",
    more: "もっと",
    close: "近い",
    video_off: "ビデオオフ",
    video_on: "ビデオオン",
    start_video: "ビデオを開始",
    stop_video: "ビデオを停止",
    disconnect: "切断する",
    mute: "ミュート",
    muted: "ミュート解除",
    powered_by_blitzz: "ブリッツによって供給",
    connecting_your_call: "接続しました。他の参加者を待っています。",
    connected: "接続済み",
    pin_is_of_nine_digit: "PIN は 9 桁である必要があります",
    preparing_image_for_markup: "マークアップ用の画像を準備しています…",
    clear_markup_confirmation: "すべてのユーザーから画像マークアップをクリアしますか?",
    clear_markup: "マークアップをクリア",
    clear: "クリア",
    close_markup: "マークアップを閉じる",
    end_markup_confirmation: "マークアップを閉じてもよろしいですか?",
    end: "終わり",
    agent_has_ended_markup_cannot_continue_without_agent:
        "エージェントはマークアップを終了しました。エージェントなしではマークアップを続行できません",
    joining_image_markup: "マークアップ用の画像を読み込んでいます…",
    cleared_markup: "すべてのユーザーの画像マークアップが消去されました。",
    capturing_photo: "写真をキャプチャしています…",
    uploading: "アップロード中",
    image: "画像",
    image_ready_for_markup: "マークアップの準備が整った画像。",
    override_video: "これにより、他の人のビデオが停止します。続けたいですか？",
    override_screen_share: "これにより、他のユーザーの画面共有が停止されます。続けたいですか？",
    started_screen_share: "画面共有を開始しました。",
    stopped_screen_share: "画面共有を停止しました。",
    clear_all: "すべてクリア",
    start_new_call_popup: "CODE で新しい通話を開始",
    group_call_limit_reached: "グループ通話の上限に達しました",
    contact_admin_to_increase_participant_limit: "他の参加者が切断されるのを待ってから、再試行してください。",
    call_is_being_connected: "通話中です。しばらくしてからもう一度お試しください。",
    show_recording_for_training_purpose: "このセッションは録音中です。",
    you_are_sharing_the_screen: "画面を共有しています",
    location_colon: "位置：",
    date_colon: "日にち：",
    image_for_markup_has_been_downloaded: "マークアップ用の画像がダウンロードされました",
    dismiss: "解散",
    google_play_service_is_not_up_to_date: "Google Play サービスが更新されていません",
    rec: "録音",
    you_are_offline: "オフラインです。",
    markup: "マークアップ",
    exit: "出口",
    video_unsupported: "ビデオはサポートされていません",
    please_open_this_link_in_safari: "このリンクを Safari で開いてください。",
    you_are_not_able_to_see_this_video: "あなたはこのビデオを見ることができません。",
    only_number_Allowed: "数字のみが許可されます。",
    permission_warning: "権限の警告",
    unable_to_join_call_please_try_after_sometime: "通話に参加できません。しばらくしてからお試しください",
    share_live_video: "ライブ動画を共有しますか?",
    share_your_screen: "画面を共有しますか？",
    unable_access_flash: "フラッシュ ライトにアクセスできません。",
    camera_unavailable_try_again: "カメラを利用できません。もう一度お試しください。",
    unable_download_image_tomarkup: "サーバーから画像をダウンロードできません。もう一度お試しください。",
    try_again: "再試行",
    markup_screen_appear_shortly: "マークアップ画面がまもなく表示されます...",
    confirm: "確認",
    start: "始める",
    could_not_find_endpoint: "サーバー エンドポイントが見つかりませんでした。",
    please_wait: "お待ちください...",
    done: "終わり",
    ok: "Ok",
    please_try_again_with_valid_agent_id: "有効なエージェント ID で再試行してください。",
    meeting_code_not_associated_with_agent: "セッション ID は、このエージェント ID に関連付けられていません。",
    powered_by: "搭載",
    failure: "失敗",
    code: "セッションID",
    start_new_call_question: "新しい通話を開始しますか?",
    stop_sharing: "共有をやめる",
    reconnecting_call: "通話を再接続しています...",
    unable_to_access_mircrophone_or_camera: "マイクまたはカメラにアクセスできません。",
    be_sure_to_allow_access_in_browser: "ブラウザの設定でアクセスを許可してください。",
    make_sure_you_have_microphone_camera_attached: "カメラまたはマイクが接続されていることを確認してください。",
    location_blocked_by_user: "ユーザーによって場所がブロックされました",
    user_has_joined_the_call: "ユーザーが通話に参加しました",
    are_you_sure_you_want_to_close_window: "このウィンドウを閉じてもよろしいですか?",
    reset_guide: "リセットガイド",
    open_in_google_maps: "Google マップで開く",
    location_image_upload_failed: "ロケーション画像のアップロードに失敗しました",
    uploading_image: "画像をアップロードしています",
    upload_failed: "アップロードに失敗しました",
    markup_is_in_progress: "マークアップが進行中です...",
    select_language: "言語を選択する",
    checking_for_extension: "拡張子を確認しています...",
    start_incognito_mode_from_blitzz_screen_share_ext:
        "シークレット モードで画面共有を開始するには、ブラウザの Blitzz - Screen Share 拡張機能からシークレット モードを開始する必要があります。",
    click_on: "クリック",
    customize_and_control_menu: "メニューのカスタマイズと制御",
    more_tools: "その他のツール",
    extensions: "拡張機能",
    click_on_detail: "詳細をクリックしてください (ブリッツ)",
    allow_in_incognito: "シークレット モードで許可します。",
    screen_share: "画面共有",
    stop_share: "共有を停止",
    save: "保存",
    cancel_initcap: "キャンセル",
    yes_initcap: "はい",
    message_title: "メッセージ",
    device_not_compatible: "申し訳ありませんが、このデバイスには互換性がありません。",
    please_download_our_app: "続行するには、アプリをダウンロードしてください。",
    download_app: "アプリをダウンロードする",
    this_browser_is_not_supported: "このブラウザは現在サポートされていません。",
    open_in_chrome_or_install_mobile_app:
        "このリンクをコピーして最新バージョンの Google Chrome に貼り付けるか、モバイル アプリをインストールしてからもう一度お試しください。",
    open_in_safari_or_install_mobile_app:
        "このリンクをコピーして最新バージョンの Safari ブラウザに貼り付けるか、モバイル アプリをインストールしてからもう一度お試しください。",
    open_in_chrome_and_try_again: "最新バージョンの Google Chrome でこのリンクを開いて、もう一度お試しください。",
    okay_initcap: "わかった",
    would_you_like_to_install_app_or_continue_browser: "アプリをインストールして、ミーティングに参加するか、ブラウザで続行しますか?",
    continue_initcap: "継続する",
    webview_limited_support_message: "最適なエクスペリエンスを得るには、Chrome ブラウザまたはデフォルトのブラウザで開いてください。",
    continue_anyway: "とにかく続ける",
    open_in_browser: "ブラウザで開く",
    link_copied_open_in_browser: "リンクをコピーしました。ブラウザが開かない場合は、Chrome にリンクを貼り付けてください。",
    add_blitzz_extension_to_screen_share: "画面共有に Blitzz 拡張機能を追加する",
    add_to_chrome_and_confirm: "「Chrome に追加して確認」",
    add_extension: "拡張機能を追加",
    permission_error_message_camera_browser: "ブラウザの設定からカメラを有効にしてください。",
    camera_not_found: "カメラが見つかりません",
    enable_camera_and_reconnect_call: "カメラを有効にし、ページをリロードして、通話を再接続する必要があります。",
    permission_error_message_microphone_browser: "ブラウザの設定からマイクを有効にしてください。",
    microphone_not_found: "マイクが見つかりません",
    enable_microphone_and_reconnect_call: "マイクを有効にし、ページをリロードして、通話を再接続する必要があります。",
    download_failed: "ダウンロードに失敗しました",
    continue_markup: "マークアップを続行",
    save_and_exit: "マークアップを保存して終了",
    exit_markup: "マークアップを終了",
    you_are_recording_the_conversation: "現在、会話を録音しています。",
    make_sure_participant_know_they_are_being_recorded: "参加者が記録されていることを確認してください。",
    you_can_download_recordings_later: "記録したファイルは後でダウンロードできます。",
    share_without_joining_session_lanuch_showme_enter_code:
        "ShowMe セッションに参加しないと画面を共有できません。 ShowMe by Blitzz を起動し、提供されたセッション ID を入力してください。",
    call_limit_reach_contact_Admin_to_increase_limit:
        "グループ通話の上限に達しました。管理者に連絡して参加者の制限を増やすか、メンバーがセッションから退出するのを待ってください。",
    other_user_trying_share_screen_Video: "他のユーザーが画面またはビデオを共有しようとしています",
    call_has_ended: "通話が終了しました",
    would_you_like_to_save_image: "画像を保存しますか？",
    audio_unsupported: "音声がサポートされていません",
    please_install_our_app_to_continue: "続行するにはアプリをインストールしてください。",
    unable_to_play_remote_audio: "リモート オーディオを再生できません。",
    unable_to_playback_audio: "オーディオを再生できません。",
    unable_to_play_video: "ビデオを再生できません。",
    unable_to_playback_video: "ビデオを再生できません。",
    okay_cap: "わかった",
    pre_call_test: "通話前テスト",
    language: "言語",
    reset: "リセット",
    zoom_in: "ズームイン",
    zoom_out: "ズームアウトする",
    headset: "ヘッドセット",
    bluetooth: "ブルートゥース",
    live_pointer_enabled_message: "ライブポインターを開始しました。ドラッグでポインタを移動できます。",
    speaker: "スピーカー",
    live_pointer_disabled_message: "停止中のポインタ",
    step_one: "ステップ1",
    step_two: "ステップ2",
    pointer: "ポインタ",
    network_quality: "ネットワーク品質",
    participant: "参加者",
    you: "（君は）",
    reconnecting: "再接続中",
    very_bad: "ひどい",
    bad: "悪い",
    poor: "貧しい",
    good: "良い",
    excellent: "優秀な",
    loc: "ロク",
    expand: "拡大",
    collapse: "崩壊",
    network: "通信網",
    ocr_inprogress: "OCR が進行中です...",
    select_area_extract_text: "テキストを抽出する領域を選択",
    text_copied: "テキストをコピーしました",
    extract_text_from_image: "画像からテキストを抽出しています...",
    not_extract_text_from_image: "画像からテキストを抽出できませんでした。",
    try_again_clear_image_or_reselect_region: "鮮明な画像で再試行するか、抽出領域を再選択してください。",
    error: "エラー",
    occured_while_receiving_doc: "ドキュメントの受信中に発生しました。",
    return_to_video: "ビデオに戻る",
    save_entire_image: "全体を保存",
    save_cropped_image: "切り取って保存",
    text_copied_to_clipboard: "クリックしてコピー",
    extract_text: "テキストの抽出",
    stop_pointer: "停止ポインター",
    reference: "参照",
    do_not_rotate_the_phone_live_pointer_message:
        "より良い視聴体験を得るために、ライブ ポインターが有効になっている間はデバイスを回転させないでください。",
    got_it_btn: "とった！",
    email: "Eメール",
    mobile_number: "携帯電話番号",
    speed_test: "スピードテスト",
    duration: "間隔",
    preparing_image_for_OCR: "テキスト処理用の画像を準備しています…",
    agent_extract_text_from_image: "お待ちください。エージェントがキャプチャした画像からテキストを抽出しています。",
    unable_download_image_to_ocr: "処理する画像をダウンロードできません。もう一度お試しください。",
    selected_area_is_small: "選択した領域が小さすぎます。",
    please_select_large_area: "画像の広い領域を選択してください。",
    zoom_level: "ズームレベル",
    do_not_rotate_the_phone_markup_message: "見やすくするために、マークアップが有効になっている間はデバイスを回転させないでください。",
    uploaded_images: "アップロードされた画像",
    upload_completed: "アップロード完了",
    capturing: "キャプチャしています...",
    network_quality_not_available: "ネットワーク品質を利用できません",
    not_able_to_see_your_stream: "あなたのストリームを見ることができなくなります",
    device_not_supported: "デバイスがサポートされていません。",
    video_settings_need_to_be_configured_by_admin_web:
        "このデバイスをサポートするには、管理者がビデオ設定を構成する必要があります。会社の管理者または電子メールに連絡してください",
    contact: "コンタクト",
    video_paused_by_agent: "エージェントによってビデオが一時停止されました",
    screenshare_paused_by_agent: "エージェントが画面共有を一時停止しました",
    not_shared: "共有されていません",
    permission_error_message_location_browser: "ブラウザの設定から位置情報を有効にしてください。",
    network_type: "ネットワーク型",
    update_your_browser_to_share_your_screen: "画面を共有するには、ブラウザを最新バージョンに更新してください",
    image_thumb_caption: "画像",
    saved_images: "保存された画像",
    try_these_option_to_have_better_experience: "より良いエクスペリエンスを得るには、これらのオプションのいずれかを試してください。",
    some_features_are_not_supported_in_this_browser: "このブラウザでは一部の機能がサポートされていません。",
    unsupported_browser: "サポートされていないブラウザ",
    permission_message_for_screenshare: "画面領域へのアクセス許可が拒否されたか、現在のブラウザ インスタンスに画面共有へのアクセス許可がありません。",
    go_to_system_preferences: "システム環境設定に移動",
    security_privacy: "セキュリティとプライバシー",
    select_privacy_tab: "プライバシータブを選択",
    screen_recording: "画面収録",
    select_google_chrome: "Google Chrome を選択",
    use_chrome_to_share_your_screen: "Chrome または Firefox ブラウザーを使用して画面を共有する",
    agree: "同意",
    decline: "却下",
    there_was_an_error_trying_to_share_your_video: "ビデオの共有中にエラーが発生しました。",
    please_stop_video_and_start_video_again_to_resume: "再開するには、ビデオを停止してからビデオを再開してください。",
    click_the_padlock: "南京錠をクリック",
    to_the_left_of_a_web_page_address: "アドレスバーの左側。",
    clear_blocked_permission_for_share_the_screen: "権限セクションで、ブロックされている画面共有権限をすべてクリアします。",
    select_your_browser: "ブラウザを選択",
    tips_colon: "チップ：",
    your_internet_connection_is_unstable: "インターネット接続が不安定です",
    participants_connection_unstable: "参加者<participantNum>のインターネット接続が不安定です",
    draw: "描く",
    rect: "直角",
    text: "文章",
    enter_text_here: "ここにテキストを入力",
    showme_app_found: "ShowMe アプリが見つかりました",
    use_showme_app: "ShowMe アプリを使用する",
    showme_app_for_guest_user:
        "このデバイスでゲスト ユーザー向けの軽量の ShowMe アプリを検出しました。このアプリには高度な機能はありません。ブラウザを引き続き使用するには、アプリをアンインストールしてから再度参加してください。",
    participants_title: "参加者",
    bookmarks_title: "ブックマーク",
    search_or_add_new_bookmark: "検索または新しいブックマークを追加",
    create_new_bookmark: "新しいブックマークを作成",
    press_enter_or_click_on_create_new_bookmark: "Enter キーを押すか、[新しいブックマークの作成] をクリックして、新しいブックマークを追加します。",
    tap_retry_to_load: "[再試行] をタップして読み込みます",
    bookmark_saved_with_image: "画像とともに保存されたブックマーク。",
    bookmark_saved: "ブックマークを保存しました。",
    failed_to_bookmark_please_try_again: "ブックマークに失敗しました。もう一度やり直してください。",
    try_our_mobile_app: "アプリで開く",
    still_facing_issue_connect_mobile_app: "それでも問題が解決しない場合は、モバイル アプリを使用して接続してください。",
    open_in_app: "アプリで開く",
    enable_microphone_from_browser_settings: "ブラウザの設定からマイクを有効にします。",
    enable_camera_from_browser_settings: "ブラウザの設定からカメラを有効にします。",
    unable_to_access_microphone: "マイクにアクセスできません",
    special_characters_are_not_allowed: "特殊文字は使用できません。",
    home_screen: "ホーム画面",
    bookmark_added: "ブックマークを追加しました。",
    privacy_policy_popup_text_description:
        "私が抱えている技術的な問題を解決するために、自発的にカメラを使用して周囲の景色を共有することに同意します。記録が作成または保存されないことを理解しています。共有機能はいつでもオフにできます。画像を共有したくない場所、個人、アイテムにカメラを向けることはありません。また、プライバシー ポリシーを読み、同意したことを確認します。",
    allow_access_to_location: "位置情報へのアクセスを許可",
    allow_access_to_location_description: "次のポップアップで場所へのアクセスを許可して、場所を検証します。",
    ok_i_understand: "わかりました",
    allow_microphone_access: "マイクへのアクセスを許可する",
    allow_microphone_access_description: "マイクへのアクセスを許可して、他の参加者があなたの声を聞くことができるようにします。",
    allow_camera_access: "カメラへのアクセスを許可",
    allow_camera_access_description: "次のポップアップでカメラへのアクセスを許可します。",
    allow_bluetooth_access: "Bluetooth アクセスを許可する",
    allow_bluetooth_access_description: "Bluetooth へのアクセスを許可して、オーディオ ソースを切り替えます。",
    permission_error_message_for_camera:
        "アクセス許可エラー: カメラにアクセスできません。 [設定] に移動し、カメラの許可を有効にします。これにより、進行中の通話が切断されます。アプリを再起動することで再接続できます。",
    permission_error_message_for_microphone:
        "アクセス許可エラー: マイクにアクセスできません。 [設定] に移動し、マイクのアクセス許可を有効にします。これにより、進行中の通話が切断されます。アプリを再起動することで再接続できます。",
    permission_error_message_for_location:
        "アクセス許可エラー: あなたの場所にアクセスできません。 [設定] に移動し、位置情報の許可を有効にします。これにより、進行中の通話が切断されます。アプリを再起動することで再接続できます。",
    enable_microphone: "マイクを有効にする",
    enable_camera: "カメラを有効にする",
    enable_location: "場所を有効にする",
    enable_bluetooth: "Bluetooth を有効にする",
    audio_issue_ios: "オーディオの問題？",
    toggle_mic_icon_guest_msg: "上の赤いマイク/カメラ アイコンを切り替えるか、電話の音声を使用します (PSTN)。",
    toggle_mic_icon_agent_msg: "上の赤いマイク/カメラ アイコンを切り替えるか、電話の音声を使用するように iOS ユーザーに要求します (PSTN)。",
    audio_ios_msg_read_more: "続きを読む",
    error_occured_in_processing_the_request: "リクエストの処理中にエラーが発生しました。もう一度やり直してください。",
    markup_ocr_upload_timeout: "通常より時間がかかります。",
    markup_cancelled: "マークアップがキャンセルされました",
    ocr_cancelled: "テキストの抽出がキャンセルされました",
    click_here: "ここをクリック",
    to_return_to_video_and_try_again: "ビデオに戻り、もう一度やり直してください。",
    markup_exit: "マークアップを停止しました",
    ocr_exit: "テキストの抽出",
    camera: "カメラ",
    camera_blocked: "カメラがブロックされました",
    microphone: "マイクロフォン",
    microphone_blocked: "マイクがブロックされました",
    speakers: "スピーカー",
    speakers_blocked: "ブロックされたスピーカー",
    grant_permission: "許可を与える",
    play_test_sound: "テストサウンドを再生",
    call_settings: "通話設定",
    allow_access_to_camera: "カメラへのアクセスを許可します。",
    allow_access_to_mic: "マイクへのアクセスを許可します。",
    default_label: "デフォルト",
    do_not_rotate_the_phone_OCR_message: "見やすくするために、[テキストの抽出] が有効になっている間はデバイスを回転させないでください。",
    test_connection: "テスト接続",
    browser_not_supported: "ブラウザはサポートされていません",
    your_browser_not_support_video: "お使いのブラウザはビデオ通話をサポートしていません。",
    open_link_in_google_samsung_browser:
        "このリンクをコピーして、Google Chrome または Samsung インターネット ブラウザの最新バージョンに貼り付けてください。",
    open_link_in_safari_browser: "このリンクをコピーして、最新バージョンの Safari ブラウザーに貼り付けてください。",
    copy_link: "リンクをコピーする",
    copy_code: "コードをコピー",
    guest_url_copy: "クリップボードにコピーされたゲスト URL。",
    session_code_copy: "セッション ID がクリップボードにコピーされました。",
    meeting_code_lable: "会議コード",
    add_participant_lable: "参加者を追加",
    send_this_link_to_guest: "このリンクをゲストに送信します",
    send_an_email: "メールを送る",
    or_label: "また",
    remote_mic_cam_error: "リモート参加者のマイク/カメラにエラーがあります。",
    device_not_supported_or_permi_block: "デバイスがサポートされていないか、権限がブロックされています。",
    remote_participant: "リモート参加者",
    microphone_unmuted: "マイクのミュートが解除されました",
    microphone_muted: "マイクミュート",
    camera_on: "カメラオン",
    camera_off: "カメラオフ",
    earpiece: "イヤーピース",
    error_label: "エラー",
    cannot_start_video: "ビデオを開始できません",
    failed_to_start_video_camera: "ビデオカメラの起動に失敗しました。",
    please_select_another_camera_from_call_settings: "通話設定から別のビデオ カメラを選択してください。",
    please_select_another_video_camera: "別のビデオカメラを選択してください。",
    chat: "チャット",
    chat_info: "チャット メッセージは、通話中の全員に表示されます。設計上、切断するとチャット履歴は完全に消えます。",
    chat_input_placeholder: "メッセージを入力してください",
    participant_connected: "<participantCount>人の参加者が接続しました",
    click_to_share_invite: "クリックして招待を共有",
    remote_flashlight_not_supported_on_guest_device_or_not_ready: "リモート懐中電灯がゲスト デバイスでサポートされていないか、準備ができていません",
    pin_a_video_tile_above_to_use_this_feature: "この機能を使用するには、上のビデオ タイルをピン留めしてください",
    pin_video_for_all_participants: "すべての参加者にビデオを固定する",
    return_to_gallery_view: "ギャラリー ビューに戻る",
    override_own_screen_share: "画面共有が停止されます。続けたいですか？",
    override_own_video: "動画が停止されます。続けたいですか？",
    you_have_started_the_video: "動画を開始しました",
    back_lable: "戻る",
    front_lable: "フロント",
    blur: "ぼかし",
    mask_lable: "マスク",
    view_text: "意見",
    stop_label: "止まる",
    recording_stopped: "記録停止",
    error_recording_please_try_again: "記録中にエラーが発生しました。もう一度お試しください",
    error_recording_wait_or_disconnect_call: "エラー記録。ホストが記録を停止するまでお待ちください。または、切断して後で再参加することもできます。",
    wait_for_recording: "録画を開始するまでお待ちください...",
    max_participant_limit_for_recording:
        "最大。記録中に参加者の上限に達しました。ホストが記録を停止するまでお待ちください。または、切断して後で再参加することもできます。",
    start_recording: "録音が開始されました。",
    stop_recording: "記録が停止されました。",
    arrow: "矢印",
    error_recording_all_participants: "すべての参加者の記録中にエラーが発生しました。",
    please_stop_and_restart_recording: "記録を停止して再開してください。",
    some_participants_will_not_be_recorded: "一部の参加者は記録されません。",
    participant_limit_reached: "参加者の制限に達しました。",
    your_account_has_4_participant_limit_while_recording: "あなたのアカウントには、記録中の参加者の制限が 4 つあります。",
    disconnect_call: "通話を切断",
    record_title: "記録",
    stop_recording_btn: "記録を停止",
    back_to: "戻る",
    remind_me_later: "後で通知する",
    skip_this_update: "この更新をスキップ",
    cam_per_denied_msg: "参加者の 1 人が、デバイスでカメラへのアクセスをブロックしている可能性があります。それらをガイドするには、表示してください",
    mic_per_denied_msg: "参加者の 1 人が、デバイスでマイクへのアクセスをブロックしている可能性があります。それらをガイドするには、表示してください",
    cam_mic_per_denied_msg:
        "参加者の 1 人が、デバイスでカメラとマイクへのアクセスをブロックしている可能性があります。それらをガイドするには、表示してください",
    your_camera_block: "カメラがブロックされています",
    your_microphone_block: "マイクがブロックされています",
    your_location_block: "現在地がブロックされています",
    we_cannot_access_your_camera: "カメラにアクセスできません。",
    we_cannot_access_your_microphone: "マイクにアクセスできません。",
    we_cannot_access_your_location: "現在地にアクセスできません。",
    go_to_browser_settings: "アクセスを許可するには、ブラウザの設定に移動し、ここをクリックしてページをリロードしてください。",
    still_facing_issue: "まだ問題に直面していますか？",
    try_the: "を試す",
    mobile_app: "モバイルアプリ",
    view_help_article: "ヘルプ記事を見る",
    enable_or_attach_camera_and_reconnect_call: "カメラを有効にするか接続し、ページをリロードして通話を再接続する必要があります。",
    enable_or_attach_microphone_and_reconnect_call: "マイクを有効にするか接続し、ページをリロードして通話を再接続する必要があります。",
    per_denied_common_msg: "ブラウザーのアクセス許可をリセットするための簡単なヒントについては、 を参照してください。",
    start_rec_label: "録画開始",
    stop_rec_label: "記録停止",
    start_recording_tooltip_label: "録音開始",
    cam_per_denied_title: "リモート参加者のカメラがブロックされました",
    mic_per_denied_title: "リモート参加者のマイクがブロックされました",
    cam_mic_per_denied_title: "リモート参加者のカメラとマイクがブロックされました",
    these_instructions: "これらの指示",
    click_here_label: "ここをクリック",
    from_participant: "参加者から",
    download_key: "ダウンロード",
    download_not_supported_text: "お使いのデバイスではダウンロードがサポートされていません。",
    undo: "元に戻す",
    redo: "やり直し",
    fill: "塗りつぶし",
    Whisper_on: "ウィスパーオン",
    Whisper_off: "ささやきオフ",
    enable_whisper_tooltip_label: "ウィスパーを有効にしてホストと話す",
    host_can_hear_you_now: "ホストはあなたの声を聞くことができます",
    mediate_lable: "仲介する",
    join_call_as_participant: "参加者として通話に参加",
    observer_lable: "観察者",
    silent_observer_connect_alert_popup: "オブザーバーとして接続されています。マイクとカメラはミュートされています。",
    click_mediate_if_you_would_like_to_join_as_a_participant: "参加者として参加したい場合は、「仲介」をクリックしてください。",
    Silent_observer_lable: "沈黙の観察者",
    invite_participant_tooltip_lable: "Silent Observer のマイクとカメラはミュートされ、ゲスト参加者には表示されません。",
    send_link_silent_observer: "このリンクをサイレント オブザーバーに送信します。",
    join_as_mediator_title: "メディエーターとして参加しますか?",
    join_as_mediator_popup_description:
        "参加者として通話に参加してもよろしいですか?下の「確認」をクリックし、次の画面で「接続」をクリックして、参加者（仲介者）として参加します。",
    guest_lable: "ゲスト",
    overall_experience: "全体的な経験？",
    leave_comment: "コメントを残す (オプション)",
    sent: "送信済",
    send: "送信",
    color_label: "色",
    view_unavailable: "閲覧不可",
    thanks: "ありがとう！",
    whisper_label: "ウィスパー",
    stop_recording_tooltip_label: "ギャラリーモードに戻り、記録を停止します。",
    save_image: "画像を保存",
    screenshare_mweb_text: "デバイスからの画面共有にはアプリが必要です。このセッションはモバイル アプリから接続してください。",
    disconnect_and_launchapp_btn: "切断してアプリを起動",
    device_battery_low: "デバイスの電池残量が少ない",
    notes_lable: "ノート",
    new_note_lable: "新しいメモ",
    only_visible_to_you: "自分だけに見える",
    empty_note: "空のメモ",
    title_lable: "題名",
    delete_lable: "消去",
    delete_Note: "メモを削除",
    want_delete_this_note: "このメモを削除してもよろしいですか?",
    failed_delete_note: "メモを削除できませんでした。",
    note_deleted_successfully: "メモを削除しました",
    failed_edit_note: "メモの編集に失敗しました。",
    note_edited_successfully: "メモを更新しました",
    failed_add_note: "メモを追加できませんでした。",
    note_added_successfully: "追記しました",
    batteryinfo_tooltip: "デバイスのバッテリー情報",
    screenshare_mweb_title: "アプリのダウンロードが必要",
    screenshare_mweb_desc1: "デバイスからの画面共有にはアプリが必要です。",
    screenshare_mweb_desc2: "アプリをダウンロードします。",
    upcoming_event: "これから起きる出来事",
    scheduled_to_start_in: "開始予定",
    please_wait_for_the_host_to_start_this_event: "主催者がこのイベントを開始するまで待ってから、もう一度お試しください。",
    image_deleted: "画像を削除しました",
    failed_to_delete_image: "画像を削除できませんでした",
    are_you_sure_you_want_to_delete_image: "この画像を完全に削除してもよろしいですか?",
    delete_image_title: "画像を削除",
    sms_sent_label: "SMS を送信しました!",
    whatsapp_sent_label: "WhatsAppの招待状を送信しました!",
    whatsapp_label: "ワッツアップ",
    email_sent_label: "メールを送信しました!",
    smartglass_sent_label: "Smartglass 招待状を送信しました!",
    schedule_to_start_in_a_few_seconds: "数秒後に開始予定。",
    location_image_thumb_caption: "ロケーションイメージ",
    updated_successfully: "更新成功",
    edit_label: "編集",
    scan_code_lable: "スキャンコード",
    scan_code_result: "スキャンコードの結果",
    extract_text_result: "テキスト結果の抽出",
    scan_code_result_not_found: "画像から QRcode/Barcode をスキャンできませんでした。鮮明な画像でもう一度お試しください。",
    host_features_will_not_be_available_when_using_app: "アプリを使用している場合、ホスト機能は利用できません",
    note_colon: "ノート：",
    leave_lable: "離れる",
    are_you_sure_you_want_to_leave_this_call: "この通話を終了してもよろしいですか？",
    supported_browser_versions: "サポートされているブラウザのバージョン",
    see: "見る",
    call_disconnected: "通話が切断されました",
    video_quality: "ビデオ品質",
    low_bandwidth: "低帯域幅",
    adaptive: "アダプティブ",
    high_quality: "高品質",
    wait_for_the_call_to_start: "通話が開始されるまで待ちます",
    enter_email_send: "メールを入力して招待状を送信",
    send_invitaion_lable: "招待状を送る",
    enter_mobile_number_lable: "携帯電話番号を入力",
    enter_valid_mobile: "有効な携帯電話番号を入力してください。",
    dont_show_this_again: "今後表示しない",
    share_invitation_with_others: "セッションへの招待を他のユーザーと共有する",
    new_email_address: "電子メールアドレス",
    invite_participant_lable: "参加者を招待",
    saved_label: "保存しました！",
    show_stream: "見せる",
    hide_stream: "隠れる",
    has_sent_you_link_for_video_conference: "<company_name>からライブ ビデオ会議のリンクが送信されました。",
    copy_invitation: "招待状をコピー",
    copy_invitation_desc: "スケジュールされた時間で招待テキストをコピーし、手動で送信します",
    copied: "コピーしました！",
    copy_session_code: "セッションIDをコピー",
    copy_link_to_share: "リンクをコピーして共有",
    session_invitation_copied: "セッションへの招待がクリップボードにコピーされました。",
    observer_url_copied: "オブザーバーの URL がクリップボードにコピーされました。",
    invite_sent_successfully: "招待状を送信しました",
    sms_label: "SMS",
    copy: "コピー",
    enter_valid_email: "有効なメールアドレスを入力してください。",
    limit_exceeded: "限度超過",
    other: "他の",
    join_the_session: "セッションに参加する",
    camera_permission_required_title: "カメラの許可が必要です",
    camera_permission_required_disc1: "ライブ ビデオを共有するには、ブラウザの設定でカメラの許可をオンにしてから、",
    reload_page_disc: "ページをリロードします。",
    location_permission_required_title: "場所の許可が必要です",
    microphone_permission_required_title: "マイクの許可が必要です",
    confirmation_lable: "を読んで同意したことを確認できます",
    live_location: "ライブロケーション",
    no_one_shared_location: "誰も現在地を共有していません",
    it_was_great_lable: "よかった",
    not_so_great_lable: "あまり良くない",
    link_copied: "リンクをコピーしました",
    whats_new: "新着情報",
    microphone_publication_description: "マイクが見つからないか、他のアプリケーションで使用されている可能性があります。",
    please_close_all_other_application: "マイクを使用している可能性のある他のすべてのアプリケーションを閉じてから、もう一度お試しください。",
    app_to_share_your_device_screen: "この通話をアプリで続行して、デバイスの画面を共有します",
    launch_app: "アプリを起動",
    screen_share_requires_app: "画面共有にはアプリが必要です。",
    only_takes_few_seconds: "これには数秒しかかかりません。",
    download_app_from_app_store_and_then_return_page: "App Store からアプリをダウンロードしてから、このページに戻ってください。",
    click_to_download_app: "クリックしてアプリをダウンロード",
    go_to_Step_2: "すでにアプリをダウンロードしている場合は、手順 2 に進みます",
    next_lable: "次",
    rejoin_the_call_in_app: "アプリで通話に再び参加する",
    step2_screen_share_description: "アプリをダウンロードしたら、アプリでこの通話に再度参加し、[画面共有] を選択してモバイル画面を共有できます。",
    disconnect_the_call_in_browser: "これにより、ブラウザで通話が切断されます",
    back_btn_lable: "戻る",
    rejoin_call_in_app: "アプリで通話に再参加",
    beta_release_tag_des1: "この機能は現在ベータ版です。",
    email_support_feedback: "フィードバックを共有するには、support@blitzz.co に電子メールを送信してください。",
    would_you_like_to_exit_markup: "マークアップを終了しますか?",
    live_captions: "自動字幕起こし",
    starting_label: "起動...",
    live_captions_started: "自動字幕起こしを開始しました。",
    spoken_language_is_set_to_english: "音声言語は英語に設定されています。",
    current_position: "現在位置",
    start_point: "出発地点",
    click_to_open_more_information: "クリックして詳細情報を開く",
    free_account: "無料アカウントを作成する",
    open_in_safari_chrome_or_install_mobile_app:
        "このリンクをコピーして最新バージョンの Safari または Google Chrome ブラウザに貼り付けるか、モバイル アプリをインストールしてからもう一度お試しください。",
    continue_without_name: "名無しで続ける",
    enter_your_name: "あなたの名前を入力してください",
    unable_to_start_the_video_please_download_the_app_to_continue: "ビデオを開始できません。アプリをダウンロードして続行してください。",
    ignore: "無視",
    screen_share_info:
        "インフィニティ ミラーを回避するには、画面全体またはブラウザー ウィンドウを共有しないでください。代わりに、タブまたは別のウィンドウだけを共有してください。",
    screen_share_to_everyone: "画面を全員に共有しています",
    stop_share_screen: "画面共有を停止",
    upload: "アップロード",
    from_device: "デバイスから",
    from_camera: "カメラから",
    upload_failed_files: "失敗したファイルのアップロード",
    uploaded_max_file: "許可されている最大数のファイルをアップロードしました。",
    upload_files: "ファイルのアップロード",
    upload_limit_reached: "アップロードの上限に達しました",
    drop_for_upload_or_select: "ここにドロップしてアップロードするか、選択します",
    upload_20_file: "一度に最大 20 個のファイルをアップロードします。",
    max_size_20MB: "最大。ファイル サイズ<fileSize> MB。",
    cancel_upload: "アップロードをキャンセル",
    cancel_upload_alert: "アップロードをキャンセルしますか?",
    file_details_deleted: "ファイルに追加された詳細はすべて削除されます。",
    uploaded_files: "アップロードされたファイル",
    capture_image: "画像をキャプチャ",
    participant_uploading_file_msg: "他の参加者がファイルをアップロードしている間、お待ちください。",
    previous: "前",
    removed_more_than_20MB_file: "サイズが<fileSize> MB を超えるファイルは削除されます。",
    uploading_files: "ファイルのアップロード",
    add_caption: "字幕を追加...",
    max_file_count: "一度に最大<fileCount>のファイルをアップロードできます。",
    upload_failed_file_count: "アップロードに失敗しました: <numberOfFailedFiles>個のファイルがアップロードされませんでした。",
    uploaded_files_of_a_maximum: "最大<totalCount>の<successCount>個のファイルをアップロードしました",
    you_have_selected_the_maximum_number_of_files_allowed: "許可されているファイルの最大数を選択しました。",
    upload_max_count: "最大<remainingCount>個のファイルをアップロードしてください。",
    delete: "消去",
    recipients_can_upload_files: "受信者はファイルをアップロードできるようになりました。",
    image_upload_msg: "画像をアップロードしています。しばらくお待ちください",
    unselect: "選択解除",
    uploading_dots: "アップロード中…",
    finished_uploading: "アップロード完了",
    upload_files_msg: "ファイルのアップロード",
    loading_image_counter: "<totalCount>の画像<counter>を読み込んでいます",
    return_to_home_screen: "ホーム画面に戻る",
    close_tab: "タブを閉じる",
    closing_tab: "タブを閉じる",
    session_code_expire_msg: "このリンクは閉鎖されました",
    view_call_logs: "通話履歴を表示する",
    measurements: "測定",
    cm: "cm",
    copy_all: "すべてコピー",
    length_approximate: "長さ（概算）",
    measure_units: "計測単位",
    units: "単位",
    metric: "メトリック",
    imperial: "インペリアル",
    list: "リスト",
    ready_for_measurement: "測定準備完了",
    find_surface_to_measure: "測定する近くの表面を見つける",
    measurement: "計測",
    preparing_ar_measurement: "測定用のビューを準備しています...",
    slow_down: "徐行",
    move_further_away: "さらに離れて移動",
    more_light_required: "より多くの光が必要",
    camera_use_bu_another_app: "カメラは別のアプリで使用されています",
    tacking_not_available: "追跡は利用できません",
    move_device_to_start: "デバイスを移動して開始",
    app_required_for_measurement: "測定に必要な対応アプリ",
    app_required_update_for_measurement: "測定には対応アプリのアップデートが必要です",
    device_required_google_play_service: "3D 測定を開始するには、参加者のデバイスに Google Play サービスをインストールする必要があります",
    device_required_update_google_play_service: "参加者のデバイスは、3D 測定を開始するために Google Play サービスを更新する必要があります。",
    device_not_compatible_for_measurement: "測定に対応していないデバイス",
    device_not_support_google_play_service: "参加者のデバイスは、3D 測定に必要な Google Play サービスをサポートしていません",
    view_supported_device: "サポートされているデバイスを表示",
    measure: "測定",
    measurement_copied_msg: "クリップボードにコピーされた測定値",
    app_required: "この機能にはアプリのダウンロードが必要です。 <learnmore>",
    measurement_cancelled: "測定中止",
    learn_more: "もっと詳しく知る",
    app_to_support_ar_measurement: "AR 測定をサポートするには、アプリでこの通話を続けてください",
    ar_measurement_description_step1: "拡張現実測定機能により、オブジェクトを 3D で測定できます。アプリのダウンロードが必要です",
    ar_measurement_description_step2: "アプリをダウンロードした後、アプリでこの通話に再度参加し、[測定] を選択して AR 測定を開始できます。",
    beta: "ベータ",
    measurement_toast_msg_to_guide_user:
        "最良の結果を得るには、端末から 0.5 ～ 3 メートル (2 ～ 10 フィート) 離れた明確な対象物に対して測定を使用します。",
    measurement_toast_note_to_guide_user: "注: 測定値は概算です。",
    having_audio_issue: "オーディオに問題がありますか?",
    remote_participant_voice_not_coming_description: "現在、他の参加者の声が聞こえない、または何らかの音声の問題が発生しているようです。",
    workaround_action_for_remote_audio_not_coming: "<click_here>をクリックして、簡単な回避策を適用します。",
    click_here_for_audio_label: "ここをクリック",
    measurement_copyall_msg: "クリップボードにコピーされた測定値",
    armarkup_cancelled: "AR マークアップがキャンセルされました",
    device_not_support_google_play_service_for_markup: "参加者のデバイスは、3D マークアップに必要な Google Play サービスをサポートしていません",
    device_required_update_google_play_service_for_markup:
        "3D マークアップを開始するには、参加者のデバイスで Google Play サービスを更新する必要があります。",
    device_required_google_play_service_for_markup:
        "参加者のデバイスに 3D マークアップを開始するには、Google Play サービスをインストールする必要があります",
    device_not_compatible_for_AR_Markup: "AR マークアップに対応していないデバイス",
    app_required_update_for_AR_Markup: "AR マークアップに必要な対応アプリの更新",
    app_required_for_AR_Markup: "ARマークアップに必要な対応アプリ",
    preparing_view_for_ar_markup: "AR マークアップのビューを準備しています...",
    AR_Markup_Lable: "AR マークアップ",
    armarkup_toast_msg_to_guide_user:
        "最良の結果を得るには、スマートフォンから 0.5 ～ 3 メートル (2 ～ 10 フィート) 離れた明確なオブジェクトにマークアップを使用します。",
    ar_live_streaming_ready_to_markup: "AR ライブ ストリーミングをマークアップする準備ができました。",
    ar_markups_cleared_for_all_users: "すべてのユーザーの AR マークアップがクリアされました。",
    ar_live_streaming_marking_stopped: "ARライブ配信マーキング停止",
    agent_has_ended_ar_markup_cannot_continue_without_agent:
        "エージェントは AR マークアップを終了しました。エージェントなしでは AR マークアップを続行できません",
    ar_markup_cancelled: "AR マークアップがキャンセルされました",
    ready_for_ar_markup: "AR マークアップの準備完了",
    max_ar_arrow_limit_toast_message: "矢印の制限に達しました。さらに追加するには、すべてクリアを使用してください。",
    video_paused: "ビデオが一時停止されました",
    discard_label: "破棄",
    discard_image_label: "画像を破棄",
    save_image_label: "画像を保存",
    go_room_call_limit_reached: "Go ルームの通話制限に達しました",
    circle: "丸",
    arrow_with_text: "テキスト付きの矢印",
    add_shadow_and_stroke: "影とストロークを追加する",
    font_label: "フォント：",
    file_type_not_supported: "ファイルの種類はサポートされていません",
    crt_acnt_enter_confirm_password: "",
    create_new_note_description: "メモの作成を開始するには、下の [新しいメモ] ボタンをクリックしてください。",
    remote_user_stream_interrupted: "リモート ユーザー ストリームが中断されました",
    audio_disabled_by_admin: "管理者によってオーディオが無効になっています",
    audio_disabled: "オーディオが無効です",
    dont_show_again: "再度表示しない",
    having_an_issue_with_joining_the_call: "通話に参加する際に問題が発生していますか?",
    to_perform_network_check: "ネットワークチェックを実行する",
    you_were_removed_from_the_call_by_the_host: "主催者によって通話から削除されました",
    you_have_been_removed_from_the_call_by_the_host_and_cannot_rejoin_now: "主催者によって通話から削除されたため、現在再参加することはできません。",
    host_removed_you_from_the_call: "ホストがあなたを通話から削除しました。",
    unable_to_join_the_call: "通話に参加できません",
    host_muted_your_microphone: "ホストがあなたのマイクをミュートしました。",
    unmute_your_microphone: "マイクのミュートを解除する",
    host_invites_you_to_speak_unmute_your_microphone_when_ready:
        "ホストがあなたに発言を依頼しています。準備ができたらマイクのミュートを解除してください。",
    got_it: "わかった",
    unmute_mic: "マイクのミュートを解除",
    host_turned_off_your_camera: "ホストがカメラをオフにしました。",
    turn_your_camera_on: "カメラをオンにする",
    host_invites_you_to_turn_your_camera_on: "ホストがカメラをオンにするよう促しています。",
    turn_camera_on: "カメラをオンにする",
    start_sharing_your_screen: "画面共有を開始する",
    host_invites_you_to_share_your_screen: "ホストが画面の共有を招待しています。",
    share_screen: "画面を共有",
    remove_all: "すべて削除",
    remove: "取り除く",
    end_call: "通話終了",
    removing_all_participants_will_end_the_call: "すべての参加者を削除すると通話が終了します。",
    are_you_sure_you_want_to_remove_from_this_call: "この通話から<participantName>を削除してもよろしいですか?",
    block_from_rejoining_this_call: "<participantName>がこの通話に再度参加することをブロックする",
    turn_all_mics_off: "すべてのマイクをオフにする",
    turn_all_cams_off: "すべてのカメラをオフにする",
    ask_to_turn_mic_on: "マイクをオンにするよう依頼する",
    turn_mic_off: "マイクをオフにする",
    turn_cam_off: "カメラをオフにする",
    ask_to_turn_cam_on: "カメラをオンにするよう依頼する",
    ask_to_share_screen: "画面共有を依頼する",
    having_a_video_problem: "ビデオに問題がありますか?",
    ios_play_pause_modal_body_text:
        "この問題を解決するには、携帯電話の省電力モードを無効にしてください。または、下の再生ボタンをクリックして、とりあえずビデオを再生してください。",
    play_video: "ビデオを再生",
    camera_request_sent: "カメラリクエストが送信されました。",
    waiting_for_host_approval: "ホストの承認を待っています。",
    microphone_request_sent: "マイクのリクエストが送信されました。",
    camera_request_denied: "カメラのリクエストが拒否されました。",
    click_the_camera_icon_if_you_need_to_request_again: "再度リクエストする必要がある場合は、カメラアイコンをクリックしてください。",
    microphone_request_denied: "マイクのリクエストが拒否されました。",
    click_the_mic_icon_if_you_need_to_request_again: "再度リクエストする必要がある場合は、マイクのアイコンをクリックしてください。",
    deny: "拒否",
    allow: "許可する",
    user_wants_to_start_their_camera: "<ParticipantName> <micOrCam>を開始したいと考えています",
    error_in_processing_live_caption_please_retry: "ライブキャプションの処理中にエラーが発生しました。再試行してください。",
    virtual_background: "仮想背景",
    upload_image: "画像をアップロード",
    remove_image: "画像を削除",
    remove_background_image: "背景画像を削除する",
    are_you_sure_you_want_to_remove_background_image: "背景画像を削除してもよろしいですか?",
    unsupported_file_format: "サポートされていないファイル形式です。",
    the_maximum_file_size_supported_is_in_mb: "サポートされる最大ファイル サイズは<size> MB です。",
    no_effect: "効果なし",
    blur_background: "背景をぼかす",
    default_image: "デフォルト画像",
    virtual_background_not_supported: "仮想背景はサポートされていません。",
    remove_from_call: "通話から削除",
    enable_offline_mode: "オフラインモードを有効にする",
    offline_mode_enabled: "オフラインモードが有効",
    your_images_will_upload_when_you_reconnect: "再接続すると画像がアップロードされます。",
    please_keep_this_screen_open: "この画面を開いたままにしておいてください。",
    max_images_upload: "最大<count>画像",
    remaining_image_count_label: "<totalCount>中<remainingCount>の画像",
    selected_images: "厳選画像",
    offline_uploads_are_not_supported_in_private_mode: "プライベートモードではオフラインアップロードはサポートされません。",
    please_switch_to_a_normal_browser_tab_to_use_this_feature: "この機能を使用するには、通常のブラウザタブに切り替えてください。",
    guest_is_using_a_private_browser_window: "ゲストはプライベートブラウザウィンドウを使用しています。",
    offline_upload_mode_is_not_supported_in_this_case: "この場合、オフラインアップロードモードはサポートされません。",
    some_images_failed_to_upload_due_to_a_network_error: "ネットワークエラーのため、一部の画像のアップロードに失敗しました。",
    closing_this_modal_will_discard_all_the_images_you_have_selected_during_offline_mode:
        "このモーダルを閉じると、オフライン モード中に選択したすべての画像が破棄されます。",
    live_captions_stopped: "ライブキャプションが停止しました",
    translate: "翻訳する",
    auto_translate: "自動翻訳",
    your_language: "あなたの言語",
    translation_info_text: "他の参加者からのメッセージは、選択した言語に自動的に翻訳されます。",
    translating: "翻訳中...",
    show_original: "オリジナルを表示",
    show_translation: "翻訳を表示",
    translated: "翻訳済み",
    send_message_in: "メッセージを送信",
    audio_translation: "翻訳",
    audio_translation_setup: "音声翻訳",
    they_speak: "相手の言語",
    i_want_to_hear: "聞きたい言語",
    start_translation: "翻訳を開始",
    stop_translation: "翻訳を停止",
    starting_translation: "翻訳を開始しています...",
    translation_started: "音声翻訳が開始されました。",
    translation_stopped: "音声翻訳が停止されました。",
    translation_error: "翻訳エラーが発生しました。もう一度お試しください。",
    translation_active: "翻訳中",
    voice_type: "音声",
    voice_female: "女性",
    voice_male: "男性",
};

export default ja;
